import { Component, OnInit } from "@angular/core";
import { AtlasSvgIconRegisterService, AtlasTranslateService } from "@asfinag/atlas";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";

import { SVG_ICONS } from "./config/svg-icon-registry.config";
import { AuthService } from "./services/auth.service";
import { DigitalRoadworkService } from "./services/digital-roadwork.service";

@Component({
	selector: "dr-app-root",
	templateUrl: "./app.component.html",
	styleUrls: ["./app.component.scss"],
})
export class AppComponent implements OnInit {
	constructor(
		private readonly authService: AuthService,
		private readonly svgIconService: AtlasSvgIconRegisterService,
		private readonly translateService: AtlasTranslateService,
		private readonly digitalRoadworkService: DigitalRoadworkService,
	) {}

	public ngOnInit(): void {
		this.svgIconService.registerIcons(SVG_ICONS);
		this.translateService.init();
		dayjs.extend(customParseFormat);
		this.authService.refreshToken().subscribe(() => this.digitalRoadworkService.initialize());
	}
}
